import "react";
import e from "./chunk901.js";
import "react/jsx-runtime";
import { useDefaultProps as r } from "./chunk1148.js";
process.env.NODE_ENV !== "production" && (e.node, e.object.isRequired);
function i(o) {
  return r(o);
}
export {
  i as useDefaultProps
};
